import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { CoalService } from 'app/services/coal.service';
import { MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { AppState, selectAuthState } from 'app/store/app.states';

@Component({
  selector: 'settings-security',
  templateUrl: './security.component.html',
  styleUrls: ['./security.component.scss']
})
export class SettingsSecurityComponent implements OnInit, OnDestroy {
  securityForm: FormGroup;
  @Input() idEmpresa;
  @Input() idUser = 14;
  // passwordValidation = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&^_-]).{8,}/;
  // passwordValidation: string = '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$';
  passwordValidation: string = '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[\\W_])[A-Za-z\\d\\W_]{8,}$';
  user;
  getStateAuthentication;
  authentication;
  validationTimer: number = 86400000;
  messages = '';

  constructor(
    private coalService: CoalService,
    private _snackBar: MatSnackBar,
    private _fb: FormBuilder,
    private store: Store<AppState>
  ) {
    this.getStateAuthentication = this.store.select(selectAuthState);
    this.securityForm = this._fb.group({
      currentPassword: new FormControl('', [Validators.required]),
      newPassword: new FormControl('', [Validators.required, Validators.pattern(this.passwordValidation)]),
      passwordConfirmation: new FormControl('', [Validators.required, Validators.pattern(this.passwordValidation)])
    }, { validators: this.passwordMatchValidator });
  }
  passwordMatchValidator(g: FormGroup) {
    return g.get('newPassword').value === g.get('passwordConfirmation').value
       ? null : {'mismatch': true};
  }
  ngOnDestroy(): void {
    this.authentication.unsubscribe();
  }

  ngOnInit(): void {
    this.authentication = this.getStateAuthentication.subscribe((state) => {
      this.user = state.seguridad?.user;

      const now = new Date().getTime(); // Fecha y hora actual en milisegundos.
      const lastUpdate = new Date(this.user?.lastUpdate).getTime(); // Fecha de lastUpdate en milisegundos.
      const timeSinceLastUpdate = now - lastUpdate; // Diferencia en milisegundos.
  
      // Comprueba si han pasado menos de 24 horas (86400000 milisegundos).
      this.messages = ""
      if (timeSinceLastUpdate < this.validationTimer) {
        this.messages = "La contraseña ha sido modificada en las últimas 24 horas. Por razones de seguridad, solo puedes cambiar tu contraseña una vez cada 24 horas. Por favor, intenta nuevamente más tarde si necesitas hacer otro cambio.";
        // this._snackBar.open("La contraseña ha sido modificada en las últimas 24 horas. Por razones de seguridad, solo puedes cambiar tu contraseña una vez cada 24 horas. Por favor, intenta nuevamente más tarde si necesitas hacer otro cambio.", "OK", {duration: 10000});
        // return;
      }
    })
  }


  guardarPassword () {
    
    //  this.user.lastUpdate = "2024-07-10T21:20:57.442Z"

    // if ( new Date().getTime() >= new Date(this.user?.lastUpdate).getTime() + this.validationTimer ) {
    //   this._snackBar.open("La contraseña ha sido modificada en las últimas 24 horas.")
    //   return
    // }

    // Asegúrate de que `this.user.lastUpdate` y `this.validationTimer` están definidos correctamente.
    const now = new Date().getTime(); // Fecha y hora actual en milisegundos.
    const lastUpdate = new Date(this.user?.lastUpdate).getTime(); // Fecha de lastUpdate en milisegundos.
    const timeSinceLastUpdate = now - lastUpdate; // Diferencia en milisegundos.

    // Comprueba si han pasado menos de 24 horas (86400000 milisegundos).
    // if (timeSinceLastUpdate < this.validationTimer) {
    //   this._snackBar.open("La contraseña ha sido modificada en las últimas 24 horas. Por razones de seguridad, solo puedes cambiar tu contraseña una vez cada 24 horas. Por favor, intenta nuevamente más tarde si necesitas hacer otro cambio.", "OK", {duration: 10000});
    //   return;
    // }

  // Si han pasado más de 24 horas, continúa con el cambio de contraseña.


    this.store.dispatch(MostrarSpinner());
    let data = {
      currentPassword: this.securityForm.value.currentPassword,
      password: this.securityForm.value.newPassword,
      passwordConfirmation: this.securityForm.value.passwordConfirmation
    }
    this.coalService.postService(`auth/change-password`, data)
    .subscribe((res: any) => {
      this.store.dispatch(OcultarSpinner());
      this._snackBar.open("Contraseña actualizada correctamente.", "ok", {duration: 5000});
    }, (error: any) => {
      this.store.dispatch(OcultarSpinner());
      error?.error?.error?.status === 400 ?
				this._snackBar.open(
					error?.error?.error?.message,
					'OK',
					{ duration: 5000 }
				) : 
        this._snackBar.open(
					'Algo salió mal. Por favor, vuelva a intentarlo.',
					'OK',
					{ duration: 5000 }
				);
    });
  }
}
